import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696a6aed1beda80014347c39/kendalportfolio/src/app/about/components/AboutInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696a6aed1beda80014347c39/kendalportfolio/src/components/common/Header.tsx");
